import axios from '../../api';
import { getTimelineStatusQuery } from '../../graphql/queries/timeline.queries';

export default (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    /**
     * 
     * @param int idDossier 
     * @param string message 
     * @param int contactId
     * @returns 
     */
    let getTimelineStatus = async function (idDossier) {
        const data = JSON.stringify({
            query: `
                query {
                    ${ getTimelineStatusQuery(idDossier) }
                }
            `,
            variables: {}
        });
        const config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
        return axios(config);
    }

    return { getTimelineStatus }
}
